<template>
  <v-container>
    <v-card :class="{'elevation-2': $vuetify.breakpoint.smAndUp, 'elevation-0 rounded-0': $vuetify.breakpoint.xsOnly}">
      <v-form ref="form" lazy-validation
              :class="{'mb-8 py-10': $vuetify.breakpoint.smAndUp, 'mb-8 pt-10 pb-6': $vuetify.breakpoint.xsOnly}">
        <v-row justify="center">
          <v-col cols="11" class="pt-0">
            <h2 class="pb-5" v-if="!$vuetify.breakpoint.smAndDown">Message Content</h2>
            <h2 style="font-size: 20px;" v-else>Message Content</h2>
            <br/>
            <v-row style="display: flex; justify-content: space-between;">
              <v-col :lg="isBanner ? '12' : '6'"
                     :md="isBanner ? '12' : '6'"
                     :sm="isBanner ? '12' : '6'"
                     cols="12"
              >
                <v-text-field
                  @keydown.enter.prevent
                  class="mb-3"
                  v-model="title"
                  label="Title"
                  placeholder=" "
                  :counter="isBanner ? '70' : '39'"
                  outlined
                  :rules="titleRule"
                  required
                />
                <div class="htmlBodyContainer" v-if="isBanner">
                  <quill-editor
                    id="editor"
                    ref="myQuillEditor"
                    v-model="htmlBody"
                    :options="editorOptions"
                    @focus="handleEditorOnFocus"
                    @blur="handleEditorOnBlur"
                  >
                  </quill-editor>
                  <v-textarea
                    ref="textAreaHtmlBody"
                    v-if="isBanner"
                    :class="'mb-6 textAreaHtmlBody ' + textAreaClasses"
                    v-model="body"
                    label="Body"
                    counter="280"
                    placeholder=" "
                    outlined
                    :rules="htmlBodyRule"
                    required
                  >
                    <template v-slot:label id="Hello">
                    </template>
                  </v-textarea>
                </div>
                <v-textarea
                  v-if="!isBanner"
                  class="mb-6"
                  v-model="body"
                  label="Body"
                  placeholder=" "
                  counter="150"
                  outlined
                  :rules="bodyRule"
                  required
                />
                <v-textarea
                  v-if="!isBanner"
                  class="mb-3"
                  v-model="link"
                  label="Link (optional)"
                  placeholder=" "
                  outlined
                  :height="60"
                  hide-details
                />
                <p v-if="!isBanner">When the user(s) open the notification it will open this link in a web browser,
                  inside the Staff
                  Portal App</p>
              </v-col>
              <v-col cols="6" style="height: fit-content; display: flex; justify-content: center; margin-top: -6px;"
                     v-if="!isBanner">
                <MockPhone :body="body ? body : 'Body'" :title="title ? title : 'Title'"/>
              </v-col>
              <v-col cols="12" v-else>
                <Alert in-page
                       type="info"
                       :title="title ? title : 'Title'"
                       :html-text="htmlBody ? cleanHtmlBody : 'Body'"
                       action-text="OK, GOT IT"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-row :class="{'px-3': $vuetify.breakpoint.xsOnly}">
      <v-col lg="12"
             :class="{'pt-0 d-flex justify-space-between': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
        <AdsButton
          icon="delete"
          button-text="Discard"
          :id="$vuetify.breakpoint.xs ? 'discardButton' : null"
          secondary
          :class="{'mt-3': $vuetify.breakpoint.xsOnly}"
          @click="showDeleteDialog"
        />
        <div
          :class="{'pt-0 d-flex justify-end': $vuetify.breakpoint.smAndUp, 'pt-0 d-flex flex-column-reverse': $vuetify.breakpoint.xsOnly}">
          <AdsButton
            :loading="loadingSaveAndClose"
            button-text="Save & Close"
            tertiary
            @click="setupSubmit('close')"
            :disabled="!isValid"
            :class="{'mr-3': $vuetify.breakpoint.smAndUp, 'mt-3': $vuetify.breakpoint.xsOnly}"
            style="height: 52px;"
          />
          <AdsButton
            :loading="loadingSaveAndContinue"
            button-text="Save & Continue"
            @click="setupSubmit('continue')"
            :disabled="!isValid"
          />
        </div>
      </v-col>
    </v-row>
    <DiscardDialog v-model="deleteDialog" :delete-item="deleteItem" :show-delete-dialog="showDeleteDialog"/>
  </v-container>
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';
import DiscardDialog from "@/components/DiscardDialog";
import MockPhone from "@/components/MockPhone";
import Alert from '@/components/Alert';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {quillEditor} from 'vue-quill-editor';

import sanitizeHtml from 'sanitize-html';


export default {
  name: 'notificationStepTwo',
  components: {
    MockPhone,
    AdsButton,
    DiscardDialog,
    Alert,
    quillEditor
  },
  data: () => ({
    title: null,
    body: null,
    bodyRule: [],
    htmlBody: null,
    htmlBodyOnFocus: false,
    htmlBodyRule: [],
    editorOptions: {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'link'],
        ],
      },
      placeholder: "",
    },
    textAreaClasses: "",
    link: null,
    deleteDialog: false,
    loadingSaveAndClose: false,
    loadingSaveAndContinue: false,
  }),
  computed: {
    isValid() {
      if (this.isBanner) {
        return this.title && this.titleRule[0] === true && this.htmlBody && this.htmlBodyRule[0] === true;
      } else {
        return this.title && this.titleRule[0] === true && this.body && this.bodyRule[0] === true;
      }
    },
    titleRule() {
      if (this.title && this.isBanner && this.title.length > 70) return ['Maximum 70 characters'];
      if (this.title && !this.isBanner && this.title.length > 39) return ['Maximum 39 characters'];
      if (!this.title || this.title.length === 0) return ['Please enter a title'];
      return [true];
    },
    isBanner() {
      return this.$store.getters.currentNotification.displayMethod === 'portal_banner';
    },
    cleanHtmlBody() {
      let sanitizedHtml = sanitizeHtml(this.htmlBody);
      if (sanitizedHtml !== 'null') {
        return sanitizedHtml;
      } else {
        return null;
      }
    }
  },
  watch: {
    htmlBody() {
      //handle text area rule
      this.body = this.convertToPlainText(this.cleanHtmlBody);
      this.handleHtmlBodyRule();
    },
    body(val) {
      if (!val) {
        this.bodyRule = ['Please enter a message body'];
        if (this.htmlBodyOnFocus) {
          this.body = " ";
        }
      } else if (val.length > 150) {
        this.bodyRule = ['Maximum 150 characters'];
      } else {
        this.bodyRule = [true];
      }
    },
    htmlBodyRule(val) {
      let editor = document.getElementById('editor');
      if (val[0] !== true && editor) {
        editor.style.caretColor = '#ff5252';
      } else if (editor) {
        editor.style.caretColor = 'inherit';
      }
    }
  },
  methods: {
    handleHtmlBodyRule() {
      if (!this.htmlBody || this.htmlBody.length === 0) {
        this.htmlBodyRule = ['Please, enter a message body'];
      } else if (this.body.length > 280) {
        this.htmlBodyRule = ['Maximum 280 characters'];
      } else {
        this.htmlBodyRule = [true];
      }
    },
    handleEditorOnFocus() {
      this.htmlBodyOnFocus = true;
      let label = document.querySelector('.htmlBodyContainer .v-label');
      label.classList.add("v-label--active");
      this.textAreaClasses = 'v-input--is-focused primary--text';
    },
    handleEditorOnBlur() {
      this.htmlBodyOnFocus = false;
      this.textAreaClasses = '';
      if (!this.htmlBody || this.htmlBody.length === 0) {
        this.body = "";
        let label = document.querySelector('.htmlBodyContainer .v-label');
        label.classList.remove("v-label--active");
      }
      this.handleHtmlBodyRule();
    },
    convertToPlainText(html) {
      //based on https://dev.to/sanchithasr/3-ways-to-convert-html-text-to-plain-text-52l8
      const tempDivElement = document.createElement("div");
      tempDivElement.innerHTML = html;
      return tempDivElement.textContent || tempDivElement.innerText || null;
    },
    setupSubmit(next) {
      if (this.isValid) {

        if (next === 'close') {
          this.loadingSaveAndClose = true;
        }
        if (next === 'continue') {
          this.loadingSaveAndContinue = true;
        }

        if (!this.htmlBody && this.body) {
          this.htmlBody = this.body;
        }

        const formData = {
          message: {
            title: this.title,
            body: this.body,
            htmlBody: this.isBanner ? this.cleanHtmlBody : this.body,
            data: {
              deeplink: !this.link || this.isBanner ? null : this.link,
              type: !this.link || this.isBanner ? null : "essentials"
            }
          }
        };
        this.$store.commit('setNotificationMessageDetails', formData);
        this.$store.commit('setNotificationInfo', {status: 'Draft'});
        let draftPage = 2;
        if (this.$store.getters.currentNotification.draftPage > 2) {
          draftPage = this.$store.getters.currentNotification.draftPage;
        }
        this.$store.dispatch('updateNotification', draftPage)
          .then(() => {
            if (next === 'close') {
              this.$store.commit('setAlert', 'draft');
              this.$emit('close');
            } else {
              this.$emit('progress');
            }
          })
          .catch(err => {
            if (next === 'close') {
              this.$store.commit('setAlert', 'draftError');
              this.$router.push({name: 'notifications'});
              setTimeout(() => {
                this.$store.commit('setShowAlert', false);
                this.$store.commit('setAlert', '');
              }, 2000);
            } else {
              if (err.response && err.response.data.errMsg) {
                err = `<p>${err}</p>
                   <p>Description: ${err.response.data.errMsg}</p>`
              } else {
                err = `<p>${err}.</p>`
              }
              this.$store.commit('setErrorMessage', err);
              this.$router.push({name: 'error'});
            }
          })
          .finally(() => {
            if (next === 'close') {
              this.loadingSaveAndClose = false;
            }
            if (next === 'continue') {
              this.loadingSaveAndContinue = false;
            }
          });
      }
    },
    showDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteItem() {
      this.$store.dispatch("deleteNotification", this.$store.getters.currentNotification.draftId)
        .finally(() => {
          this.deleteDialog = false;
          this.$store.commit('setCreateMode', false);
          this.$router.push({name: "notifications"});
        });
    },
  },
  created() {
    if (this.$store.getters.currentNotification) {
      this.title = this.$store.getters.notificationMessageDetails.message.title;
      this.body = this.$store.getters.notificationMessageDetails.message.body;
      if (this.$store.getters.notificationMessageDetails.message.htmlBody) {
        this.htmlBody = sanitizeHtml(this.$store.getters.notificationMessageDetails.message.htmlBody);
      }
      this.link = this.$store.getters.notificationMessageDetails.message.data.deeplink;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/ads.scss';

.htmlBodyContainer {
  position: relative;
  min-width: 100%;
  min-height: 240px;
  margin-bottom: 24px;
}

#editor {
  z-index: 1;
  width: 100%;
  position: absolute;
}

::v-deep#editor > .ql-toolbar.ql-snow {
  border: none;
  display: flex;
  justify-content: flex-end;

  .ql-formats {
    margin-right: 0;
  }

  .ql-stroke {
    stroke: #6D7079;
  }

  .ql-fill {
    fill: #6D7079;
  }

  .ql-active .ql-stroke {
    color: #041E42 !important;
    stroke: #041E42 !important;
  }

}

::v-deep#editor > .ql-container.ql-snow {
  border: none;
}

::v-deep#editor > .ql-container > .ql-editor {
  margin-top: 8px;
  font-size: 16px;
  font-family: $body-font-family !important;
  height: 172px;
}

.textAreaHtmlBody {
  width: 100%;
  position: absolute;
  top: 44px;
}

::v-deep.textAreaHtmlBody .v-input__slot {
  min-height: 180px !important;
}

::v-deep.textAreaHtmlBody textarea {
  visibility: hidden !important;
}

.v-messages .theme--light .error--text .actionDescription {
  margin-top: 0;
}

::v-deep.theme--light .v-textarea .v-input__control .v-input__slot .v-text-field__slot label {
  font-size: 16px;
}
</style>
